import { useNavigate } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { joiResolver } from '@hookform/resolvers/joi';
import Joi from 'joi';
import Drawer from '@mui/material/Drawer';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Close from '@mui/icons-material/Close';
import { SFPalette } from '@/lib/color';
import Stack from '@mui/material/Stack';

import { inter } from '@/theme';

import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

import { sendSms } from '@/api/server/common/sendSms';
import { disableDormantAcct } from '@/api/server/common/dormant';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

// import { Lang } from '@/api/server/user/create';
dayjs.extend(duration);

// const schema = {
//   code: '',
// };
const schema = Joi.object({
  code: Joi.string().length(5),
  mobile: Joi.string().required(),
});

interface FormInputs {
  code?: string;
  country?: string;
  mobile: string;
}

interface SendMailDrawerProps {
  open: boolean;
  onClose: () => void;
}

function SendMobileDrawer({ open, onClose }: SendMailDrawerProps) {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const {
    handleSubmit,
    control,
    formState: { errors, isDirty },
    watch,
  } = useForm<FormInputs>({
    resolver: joiResolver(schema),
  });

  // useEffect(() => {
  //   (() => {
  //     const payload: sendEmailProps = {
  //       email,
  //     };
  //     sendEmail(payload);
  //   })();

  //   return () => {};
  // }, [email]);

  const onSubmit = async (data: FormInputs) => {
    if (!data.code) {
      return;
    }
    const re = await disableDormantAcct({ code: data.code });
    if (re.ret_code !== 200) {
      // ErrorRes({ code: re.ret_code, msg: re.msg });
      toast.error(`${t('toast.authFail')}`);
      return;
    }
    toast.success(`${t('toast.dormantAccountRevocation')}`);
    onClose();
  };

  const code = watch('code');
  const mobile = watch('mobile');

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          p: 3,
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
        },
      }}
    >
      <Box
        sx={{
          position: 'relative',
        }}
      >
        <IconButton onClick={onClose} sx={{ position: 'absolute', right: 0, top: 0, p: 0 }}>
          <Close />
        </IconButton>
        <Box mb={3}>
          <Typography variant="h5" gutterBottom>
            <b>{t('message.dormantAccountStatus')}</b>
          </Typography>
          <Typography variant="body2" gutterBottom color={SFPalette.grey4}>
            {'"-" 제외한 숫자를 입력한 후 전송 버튼을 누르면 인증 문자가 전송됩니다.'}
          </Typography>
        </Box>
        <Stack direction="row" mb={3.5}>
          {/* <Typography variant="body2" onClick={() => {}} color={SFPalette.grey4}>
            인증 이메일 변경하기
          </Typography>
          <ChevronRight
            sx={{
              color: SFPalette.lightGrey2,
            }}
          /> */}
        </Stack>
        <Controller
          name="mobile"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              error={!!errors.mobile}
              helperText={errors.mobile && '전화번호를 입력해 주세요.'}
              placeholder="- 제외하고 숫자만 입력해 주세요."
              sx={{
                mb: 2.5,
              }}
              fullWidth
              InputProps={{
                endAdornment: (
                  <>
                    <Typography
                      variant="body2"
                      color={SFPalette.shuffleColor2}
                      fontFamily={inter.style.fontFamily}
                      mr={1.5}
                    ></Typography>
                    <Button
                      variant="contained"
                      size="small"
                      sx={{
                        ml: 1,
                      }}
                      onClick={async () => {
                        const payload = {
                          country: '82',
                          to: mobile,
                        };
                        const re = await sendSms(payload);
                        toast.success(re.msg);
                      }}
                    >
                      전송
                    </Button>
                  </>
                ),
              }}
            />
          )}
        />
        <form onSubmit={handleSubmit(onSubmit)}>
          <Controller
            name="code"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                error={!!errors.code}
                helperText={errors.code && '인증번호 5자리를 입력하세요'}
                placeholder="인증번호 5자리 입력"
                sx={{
                  mb: 2.5,
                }}
                fullWidth
              />
            )}
          />
          <Button
            variant="contained"
            type="submit"
            disabled={!!errors.code || !isDirty || code?.length !== 5}
            size="large"
            fullWidth
          >
            인증하기
          </Button>
        </form>
      </Box>
    </Drawer>
  );
}

export default SendMobileDrawer;
